import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import Box from "@mui/material/Box";

import type { DriverRow, TagDefinition } from "@/types/driver";
import { TagChipCell } from "@/ui/TagChipCell";
import { ContextCaption } from "./ContextBlock";
import ContextTile from "./ContextTile";
import { NO_VALUE } from "./contextFormat";

/** Every workspace tag the driver carries a value for, as chips under the tag's label. */
export default function TagValuesTile({ driver, tags }: { driver: DriverRow; tags: readonly TagDefinition[] }) {
  const tagged = tags.filter((tag) => (driver.tags[tag.id]?.length ?? 0) > 0);
  return (
    <ContextTile
      icon={<SellOutlinedIcon sx={{ fontSize: 18 }} />}
      label="Tags"
      span={2}
      value={
        tagged.length === 0 ? (
          NO_VALUE
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
            {tagged.map((tag) => (
              <Box key={tag.id} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box sx={{ minWidth: 96 }}>
                  <ContextCaption>{tag.label}</ContextCaption>
                </Box>
                <TagChipCell values={driver.tags[tag.id] ?? []} activeFilter={[]} />
              </Box>
            ))}
          </Box>
        )
      }
    />
  );
}
